export default __webpack_public_path__ + "locales/el-GR/ConvertPasswordDialog.json?hash=0def76afd94c278cb45ff625e8445c82";